"use client";

import React from "react";
import RelatedTopics from "@/components/tools/RelatedTopics";
import Hero from "@/components/tools/Hero";
import IntroSection from "@/components/invisalign/before-after/IntroSection";
import WhatAreClearAligners from "@/components/invisalign/before-after/WhatAreClearAligners";
import IssuesClearAlignersFix from "@/components/invisalign/before-after/IssuesClearAlignersFix";
import BeforeAfterGallery from "@/components/invisalign/before-after/BeforeAfterGallery";
import TreatmentTimeline from "@/components/invisalign/before-after/TreatmentTimeline";
import Financing from "@/components/invisalign/before-after/Financing";
import Smile4MeApproach from "@/components/invisalign/before-after/Smile4MeApproach";
import StartJourneyCta from "@/components/invisalign/before-after/StartJourneyCta";
import FAQ from "@/components/tools/FAQ";

const invisalignFAQs = [
  {
    question: "How dramatic are the Invisalign before and after results?",
    answer:
      "Results vary by case complexity. Most patients see significant improvement in alignment, spacing, and the appearance of their smile. Mild to moderate cases often show dramatic changes within 6-12 months. Schedule a consultation for a digital simulation of your potential results.",
  },
  {
    question: "How long does it take to see changes?",
    answer:
      "Most patients notice movement within the first 4-6 weeks. Visible differences typically appear within 3 months for mild cases. Full Invisalign before and after results are achieved at treatment completion, with treatment lasting 6 to 24 months.",
  },
  {
    question: "Does Invisalign work as well as braces?",
    answer:
      "For mild to moderate alignment issues, results are clinically comparable to traditional braces, with the added benefits of removability, a nearly invisible appearance, and greater comfort. For severe cases, our team will advise you on the best option.",
  },
];

const InvisalignBeforeAfter: React.FC = () => {
  return (
    <>
      <Hero
        imageSrc="/images/Invisalign-before-and-after-showing-a-smiling-woman-in-a-blue-sweater-holding-and-pointing-to-an-invisalign-tray-against-a-light-background.webp"
        imageAlt="Invisalign-before-and-after-showing-a-smiling-woman-in-a-blue-sweater-holding-and-pointing-to-an-invisalign-tray-against-a-light-background"
        title="Invisalign Before and After Results"
        ctaText="Schedule a Consultation"
        ctaLink="/contact"
      />
      <main className="flex-1 py-8">
        <div className="flex flex-col lg:flex-row mx-auto px-4 sm:px-8 md:px-12">
          <article className="flex-1 space-y-8 pr-0 lg:pr-8">
            <IntroSection />
            <WhatAreClearAligners />
            <IssuesClearAlignersFix />
            <BeforeAfterGallery />
            <TreatmentTimeline />
            <Financing />
            <Smile4MeApproach />
            <StartJourneyCta />
            <FAQ
              title="FAQs About Invisalign Before and After Transformations"
              faqs={invisalignFAQs}
            />
          </article>
          <RelatedTopics
            topics={[
              { label: "Invisalign®", url: "/services/invisalign/" },
              { label: "Invisalign for Teens", url: "/invisalign/invisalign-for-teens/" },
              { label: "Invisalign vs Braces", url: "/invisalign/invisalign-vs-braces/" },
              { label: "Invisalign Costs", url: "/invisalign/invisalign-costs/" },
              { label: "Is Invisalign Right?", url: "/invisalign/invisalign-right/" },
              { label: "Veneers", url: "/services/veneers/" },
            ]}
          />
        </div>
      </main>
    </>
  );
};

export default InvisalignBeforeAfter;
